<template>
  <v-container fluid id="main-container" fill-height>
    <v-layout justify-center align-center row wrap>
      <v-flex xs6>
        <v-img
            src="/meldeportal/static/images/streetdancefactory.jpg"
            height="20vh"
            contain
            style="margin-bottom: 10px;"
        ></v-img>
      </v-flex>
      <v-flex xs6>
        <v-img
            src="/meldeportal/static/images/stagedancefactory.png"
            height="20vh"
            contain
            style="margin-bottom: 10px;"
        ></v-img>
      </v-flex>
      <v-flex xs10 sm8 md6 lg4>
        <v-card style="opacity: 0.9">
          <v-card-text>
            <h2>Login</h2>
            <v-text-field
                v-model="user.email"
                name="email"
                :label="$t('email_address')"
                required
                :type="'email'"
                :disabled="loading"
                @keyup.enter="login"
                autofocus
                outline
            ></v-text-field>

            <v-text-field
                v-model="user.password"
                id="password"
                name="password"
                :label="$t('password')"
                :append-icon="passwordHidden ? 'visibility' : 'visibility_off'"
                @click:append="() => (passwordHidden = !passwordHidden)"
                :type="passwordHidden ? 'password' : 'text'"
                :disabled="loading"
                @keyup.enter="login"
                required
                outline
            ></v-text-field>

            <v-layout>
              <v-flex xs6>
                <a href="/registration">Registrieren</a>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <router-link to="/reset-password">Passwort vergessen?</router-link>
              </v-flex>
            </v-layout>

            <v-btn
                @click="login"
                outline
                :loading="loading"
                :disabled="loading || !user.email || !user.password"
                block
            >
              Login
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12></v-flex>
      <v-flex xs12></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    user: {
      email: '',
      password: '',
      remember: true
    },
    passwordHidden: true,
    loading: false
  }),
  methods: {
    login() {
      this.loading = true;

      axios.post('/api/v1/token', this.user).then(response => {

        if (!response.data.success) {
          this.loading = false;
          this.$store.commit('snackBar', {
            color: 'error',
            text: this.$t('errors.' + response.data.message)
          });
          return;
        }

        let user = response.data.data;
        user.roles = user.roles.map(role => role.name);

        this.$store.dispatch('login', user);

        if (user.is_younger_than_18) {
          // TODO navigate to videos
          this.$router.push('/user/live-streams');
        } else {
          this.$router.push('/user/' + (user.valid ? 'dashboard' : 'welcome'));
        }

        this.loading = false;

      }, errorResponse => {
        console.log(errorResponse);
        this.$store.commit('snackBar', {
          color: 'error',
          text: this.$t('login_not_possible')
        });
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
#main-container {
  background: url("/meldeportal/static/images/login_background.jpg");
  background-size: cover;
}
</style>
